<template lang="pug">
  ul.lives
    li.live(v-for="item in maxValue", :id="item", :class="{ 'live_hidden' : item > count }")
</template>

<script>
export default {
  name: 'LivesCounter',
  props: ['count', 'maxValue'],
};
</script>

<style lang="scss">
  .live {
    @include retina-sprite($interface-heart-group);
    margin-right: 4px;
    @media (max-width: $max-width-xs) {
      @include retina-sprite($interface-heart-xs-group);
    }
    &:after {
      @include pseudo;
      @include retina-sprite($interface-heart-empty-group);
      opacity: 0;
      visibility: hidden;
      @include trans;
      @media (max-width: $max-width-xs) {
        @include retina-sprite($interface-heart-empty-xs-group);
      }
    }
    &:last-child {
      margin-right: 0;
    }
    &_hidden {
      &:after {
        opacity: 1;
        visibility: visible;
      }
    }
    &s {
      @include nl;
      @include vertical-align;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Interface/LivesCounter.vue